/* One private, immutable design version per cart line. No cart writes. */
(function () {
  'use strict';
  var scope = document.querySelector('[data-cart-design-previews]');
  if (!scope || scope.dataset.previewInitialized) return;
  scope.dataset.previewInitialized = 'true';
  var english = scope.dataset.previewLocale === 'en';
  var message = {
    loading: english ? 'Loading your design …' : 'Deine Gestaltung wird geladen …',
    ready: english ? 'Your design · enlarge' : 'Deine Gestaltung · vergrößern',
    error: english ? 'Preview unavailable. Please use “View saved design”.' : 'Vorschau nicht verfügbar. Bitte „Gespeicherte Gestaltung ansehen“ öffnen.',
    close: english ? 'Close preview' : 'Vorschau schließen',
    title: english ? 'Your saved design' : 'Deine gespeicherte Gestaltung'
  };

  function showLargePreview(previews, title, trigger) {
    var dialog = document.createElement('dialog');
    dialog.className = 'cart-design-dialog';
    var heading = document.createElement('h2');
    heading.id = 'CartDesignDialogTitle';
    heading.textContent = (title || '').split(/\s+[–—]\s+/)[0] || message.title;
    dialog.setAttribute('aria-labelledby', heading.id);
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cart-design-dialog__close';
    close.textContent = '×';
    close.setAttribute('aria-label', message.close);
    close.addEventListener('click', function () { dialog.close(); });
    dialog.append(close, heading);
    previews.forEach(function (preview, index) {
      var figure = document.createElement('figure');
      var image = document.createElement('img');
      image.src = preview.dataUrl;
      image.width = preview.width;
      image.height = preview.height;
      image.alt = message.title + ' – ' + (index + 1);
      figure.append(image);
      if (previews.length > 1) {
        var caption = document.createElement('figcaption');
        caption.textContent = preview.label;
        figure.append(caption);
      }
      dialog.append(figure);
    });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', function () { dialog.remove(); trigger.focus(); }, { once: true });
    document.body.append(dialog);
    dialog.showModal();
    close.focus();
  }

  async function loadPreview(host) {
    var link = host.querySelector('a');
    var status = host.querySelector('[data-cart-preview-status]');
    if (!link || !status) return;
    var savedUrl = new URL(link.href, location.origin);
    var designId = savedUrl.searchParams.get('personalize_design');
    var token = savedUrl.searchParams.get('personalize_token');
    var version = savedUrl.searchParams.get('personalize_version');
    if (!designId || !token || !/^[1-9]\d*$/.test(version || '')) return;
    status.textContent = message.loading;
    host.setAttribute('aria-busy', 'true');
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 45000);
    try {
      var endpoint = new URL('/apps/personalize-pilot/design', location.origin);
      endpoint.searchParams.set('designId', designId);
      endpoint.searchParams.set('accessToken', token);
      endpoint.searchParams.set('version', version);
      endpoint.searchParams.set('preview', 'cart');
      var response = await fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Preview unavailable');
      var data = await response.json();
      if (!data.ok || data.designId !== designId || String(data.version) !== version || !Array.isArray(data.previews) || !data.previews.length || data.previews.length > 6) throw new Error('Wrong design version');
      var previews = data.previews;
      previews.forEach(function (preview) {
        if (!/^data:image\/webp;base64,[a-z0-9+/=]+$/i.test(preview.dataUrl) || preview.width < 1 || preview.width > 1000 || preview.height < 1 || preview.height > 1000) throw new Error('Invalid preview');
      });
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cart-preview-button';
      button.setAttribute('aria-label', message.ready);
      var first = previews[0];
      var image = document.createElement('img');
      image.src = first.dataUrl;
      image.width = first.width;
      image.height = first.height;
      image.alt = message.title;
      await image.decode();
      button.append(image);
      var caption = document.createElement('span');
      caption.textContent = message.ready + (previews.length > 1 ? ' (' + previews.length + ')' : '');
      button.append(caption);
      var title = host.closest('.cart-item').querySelector('.cart-item__head a');
      button.addEventListener('click', function () { showLargePreview(previews, title && title.textContent, button); });
      link.replaceWith(button);
      status.textContent = '';
      status.hidden = true;
      host.dataset.previewReady = 'true';
    } catch (_) {
      status.textContent = message.error;
      host.dataset.previewReady = 'false';
    } finally {
      clearTimeout(timeout);
      host.removeAttribute('aria-busy');
    }
  }

  // Two simultaneous renders keep a large cart from flooding the app server.
  var pending = Array.from(scope.querySelectorAll('[data-cart-design-preview]'));
  async function worker() {
    while (pending.length) await loadPreview(pending.shift());
  }
  worker();
  worker();
}());
